import { render, staticRenderFns } from "./PayPwdSetDialog.vue?vue&type=template&id=8044aec0&scoped=true"
import script from "./PayPwdSetDialog.vue?vue&type=script&lang=js"
export * from "./PayPwdSetDialog.vue?vue&type=script&lang=js"
import style0 from "./PayPwdSetDialog.vue?vue&type=style&index=0&id=8044aec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8044aec0",
  null
  
)

export default component.exports